module.exports = __webpack_public_path__ + "/images/ico-question.64d6e52.svg";